module.exports = __webpack_public_path__ + "static/media/map_mundi_vida.cc6863d2.png";